module.exports = __webpack_public_path__ + "img/checkbox.a20fd17f.svg";